const hi = {
    "sc_title": "सुरक्षा केंद्र",
    "sc_subtitle": "GaiaShield एकीकृत सुरक्षा परत",
    "sc_tab_status": "🛡️ सुरक्षा स्थिति",
    "sc_tab_events": "📋 सुरक्षा लॉग",
    "sc_tab_node": "⚙️ नोड सुरक्षा",
    "sc_loading": "सुरक्षा डेटा लोड हो रहा है...",
    "sc_status_secured": "सिस्टम स्थिति: खाता सुरक्षित है",
    "sc_status_warning": "सिस्टम स्थिति: चेतावनियाँ सक्रिय हैं",
    "sc_desc_secured": "कोई सक्रिय महत्वपूर्ण सुरक्षा चेतावनी नहीं है। GaiaShield सक्रिय रूप से आपके खाते की निगरानी कर रहा है।",
    "sc_desc_warning": "ध्यान दें: सक्रिय सुरक्षा घटनाएँ हैं जिन पर आपका ध्यान आवश्यक है।",
    "sc_account_protection": "खाता सुरक्षा",
    "sc_message_protection": "संदेश सुरक्षा",
    "sc_audits": "सुरक्षा ऑडिट",
    "sc_active": "सक्रिय",
    "sc_failed_logins": "विफल लॉगिन",
    "sc_tamper_checks": "छेड़छाड़ की जाँच",
    "sc_blocked_replays": "अवरुद्ध रीप्ले",
    "sc_last_check": "अंतिम जाँच",
    "sc_just_now": "अभी-अभी",
    "sc_open_warnings": "खुली चेतावनियाँ",
    "sc_btn_acknowledge": "स्वीकार करें",
    "sc_filter_severity": "तीव्रता",
    "sc_filter_category": "श्रेणी",
    "sc_filter_hide_ack": "पुष्टि किए गए को छिपाएं",
    "sc_btn_export": "निर्यात करें",
    "sc_col_details": "विवरण",
    "sc_col_time": "समय",
    "sc_col_status": "स्थिति",
    "sc_col_action": "कार्रवाई",
    "sc_no_events": "कोई सुरक्षा घटना नहीं मिली।",
    "sc_node_title": "नोड ऑपरेटर सुरक्षा कंसोल",
    "sc_system_health": "सिस्टम स्वास्थ्य",
    "sc_last_audit": "अंतिम ऑडिट",
    "sc_packed_logs": "पैक किए गए लॉग",
    "sc_unconfirmed_events": "अपुष्ट घटनाएं",
    "sc_operator_action": "ऑपरेटर कार्रवाई की आवश्यकता है",
    "sc_all_ok": "सब ठीक है",
    "sc_critical_events": "महत्वपूर्ण सिस्टम घटनाएं",
    "ac_title": "शासन और दुर्व्यवहार रिपोर्ट केंद्र",
    "ac_subtitle": "GaiaCom शासन और दुर्व्यवहार आम सहमति",
    "ac_tab_my_reports": "मेरी रिपोर्ट",
    "ac_tab_queue": "समीक्षा कतार",
    "ac_tab_operator": "नोड ऑपरेटर",
    "ac_tab_transparency": "फेडरेशन और पारदर्शिता",
    "ac_loading": "डेटा लोड हो रहा है...",
    "ac_reported_cases": "रिपोर्ट किए गए मामले",
    "ac_no_reports": "आपने अभी तक कोई रिपोर्ट जमा नहीं की है।",
    "ac_case_details": "मामले का विवरण",
    "ac_appeal_submit": "अपील जमा करें",
    "ac_appeal_status": "अपील की स्थिति",
    "ac_appeal_reason": "अपील का कारण",
    "ac_appeal_statement": "बयान",
    "ac_btn_appeal": "अपील भेजें",
    "ac_trusted_reviewer_queue": "विश्वसनीय समीक्षक कतार",
    "ac_case_review": "मामले की समीक्षा",
    "ac_review_category": "अनुशंसित श्रेणी",
    "ac_review_severity": "अनुशंसित तीव्रता",
    "ac_review_action": "अनुशंसित कार्रवाई",
    "ac_review_reason": "समीक्षक का कारण",
    "ac_btn_submit_review": "समीक्षा सबमिट करें",
    "ac_node_operator_dashboard": "नोड ऑपरेटर डैशबोर्ड",
    "ac_apply_action": "कार्रवाई लागू करें (ओवरराइड)",
    "ac_target_type": "लक्ष्य प्रकार",
    "ac_target_id": "लक्ष्य आईडी (GaiaID या चैनल आईडी)",
    "ac_suspend": "निलंबन सक्रिय",
    "ac_reason": "आधिकारिक कारण",
    "ac_btn_apply": "कार्रवाई लागू करें",
    "ac_transparency_title": "आम सहमति और पारदर्शिता लॉगबुक",
    "ac_transparency_desc": "सभी मॉडरेट किए गए चैनलों और पहचानों के सार्वजनिक रूप से देखने योग्य स्ナップशॉट प्रमाण।",
    "ac_btn_snapshot": "पारदर्शिता स्नैपशॉट बनाएं",
    "search_placeholder": "विषय, प्रेषक, पाठ द्वारा मेल खोजें...",
    "abuse_center_title": "दुरुपयोग केंद्र",
    "abbrechen": "रद्द करना",
    "active_identities": "सक्रिय पहचान",
    "active_identity": "सक्रिय पहचान",
    "add_btn": "जोड़ना",
    "add_contact_title": "संपर्क जोड़ें",
    "admin": "व्यवस्थापक",
    "adressbuch": "निर्देशिका",
    "aktiviert": "सक्रिय",
    "an": "को",
    "anonymous_sender": "अज्ञात प्रेषक",
    "antworten": "उत्तर",
    "attachment_gaia_hint": "GaiaCOM अटैचमेंट एंड-टू-एंड एन्क्रिप्टेड रहते हैं।",
    "attachment_smtp_hint": "लीगेसी एसएमटीपी निष्पादन योग्य/स्क्रिप्ट-जैसे अनुलग्नकों को ब्लॉक करता है और ईमेल को असुरक्षित के रूप में सहेजता है।",
    "attachments": "संलग्नक",
    "auffaellig": "ध्यान देने योग्य",
    "auth_beta_notice": "बीटा परीक्षण चरण: GaiaCOM का सक्रिय रूप से परीक्षण किया जा रहा है। त्रुटियाँ हो सकती हैं; महत्वपूर्ण बीज सुरक्षित करें और गोपनीय कार्यप्रवाह की सावधानीपूर्वक समीक्षा करें।",
    "auth_btn_login": "पहचान लोड करें और लॉग इन करें",
    "auth_btn_register": "रजिस्टर करें और क्रिप्टो बनाएं",
    "auth_copied": "कॉपी किया गया",
    "auth_copy_seed": "प्रतिलिपि बीज",
    "auth_generate_seed": "बीज उत्पन्न करें",
    "auth_headline": "GaiaCOM मानवता के लिए निर्मित पहला क्वांटम-सुरक्षित ईमेल प्रोटोकॉल और संचार प्रणाली है।",
    "auth_kicker": "पोस्ट-क्वांटम सुरक्षित संचार",
    "auth_mnemonic": "स्मरणीय वाक्यांश",
    "auth_mnemonic_placeholder": "रिक्त स्थान से अलग किए गए 12 शब्द...",
    "auth_password": "पासवर्ड",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "निजी कुंजियाँ आपके डिवाइस को नहीं छोड़तीं। केवल इच्छित प्राप्तकर्ता ही सामग्री को डिक्रिप्ट कर सकते हैं।",
    "auth_proof_gaiadata_desc": "शून्य-ज्ञान: आप अपने डेटा पर नियंत्रण में रहते हैं। मेटाडेटा को छोटा कर दिया गया है और सादे पाठ प्रोफ़ाइल के रूप में उपयोग नहीं किया गया है।",
    "auth_proof_gaiadrop_desc": "बाहरी लोग बिना किसी खाते के आपके GaiaID पर गोपनीय पाठ संदेश भेज सकते हैं।",
    "auth_proof_gaiaproof_desc": "वितरण और अखंडता साक्ष्य से पता चलता है कि सिफरटेक्स्ट, प्रेषक और टाइमस्टैम्प के साथ छेड़छाड़ नहीं की गई है।",
    "auth_proof_gaiavault_desc": "निजी नोट, पुनर्प्राप्ति नोट और सुरक्षा रिकॉर्ड स्थानीय रूप से एन्क्रिप्टेड रहते हैं।",
    "auth_proof_hybrid_desc": "क्वांटम शील्ड: ML-KEM और X25519 के साथ हाइब्रिड एन्क्रिप्शन आज के हमलों और स्टोर-अभी-डिक्रिप्ट-बाद के जोखिमों से बचाता है।",
    "auth_secure_mail": "सुरक्षित क्वांटम फ़ेडरेटेड मेल",
    "auth_subline": "GaiaCOM ईमेल, चैट, संकट कक्ष, GaiaDrop और स्थानीय सुरक्षा फ़ाइलों के लिए एक क्वांटम सुरक्षित संचार प्रणाली है। निजी कुंजियाँ आपके डिवाइस पर रहती हैं, सामग्री एंड-टू-एंड एन्क्रिप्टेड होती है, और साक्ष्य को सादे पाठ के बिना निर्यात किया जा सकता है।",
    "auth_success_btn": "अभी लॉगिन करें",
    "auth_success_text": "आपका GaiaCOM खाता बन गया है. कुंजियाँ आपके बीज से स्थानीय रूप से प्राप्त की गई थीं और सर्वर पर संग्रहीत नहीं थीं।",
    "auth_success_title": "सफल पंजीकरण",
    "auth_tab_drop": "गैयाड्रॉप",
    "auth_tab_login": "लॉगिन खाता",
    "auth_toggle_login": "खाता पहले से मौजूद है",
    "auth_toggle_register": "नया खाता बनाएँ",
    "auth_usecase_text": "वकीलों, कंपनियों, अधिकारियों, पत्रकारों, मुखबिरों और निजी सुरक्षा मामलों के लिए उपयुक्त।",
    "auth_usecase_title": "संवेदनशील संचार के लिए निर्मित",
    "auth_username": "उपयोगकर्ता नाम",
    "auth_username_placeholder": "नाम दर्ज करें...",
    "auth_value_chat": "E2E चैट",
    "auth_value_drop": "सुरक्षित ड्रॉप",
    "auth_value_mail": "सुरक्षित मेल",
    "auth_value_rooms": "गैयारूम्स",
    "bestaetigen": "पुष्टि करना",
    "bestaetigt": "की पुष्टि",
    "bio_status": "जीवनी/स्थिति",
    "biography": "जीवनी",
    "change_password_desc": "आपका सर्वर-साइड लॉगिन पासवर्ड बदलता है। आपका स्थानीय पुनर्प्राप्ति वाक्यांश आपके वॉल्ट/अनलॉक पासवर्ड द्वारा अलग से सुरक्षित रहता है।",
    "change_password_menu_desc": "GaiaCOM लॉगिन पासवर्ड अपडेट करें।",
    "change_password_title": "पासवर्ड बदलें",
    "channel_id": "चैनल आईडी",
    "channel_name_label": "चैनल का नाम",
    "chat_deleted_hidden": "चैट हटा दी गई और छिपा दी गई.",
    "chat_input_placeholder": "सुरक्षित संदेश दर्ज करें...",
    "chat_start_hint": "बातचीत शुरू करें! सभी चैट संदेश क्वांटम सुरक्षित E2E एन्क्रिप्टेड हैं।",
    "choose_avatar": "अवतार चुनें",
    "ciphertext_hash": "सिफरटेक्स्ट हैश",
    "clear_chat": "खाली चैट",
    "clear_for_everyone": "सबके लिए खाली",
    "clear_for_me": "सिर्फ मेरे लिए खाली",
    "click_to_write_mail": "ईमेल लिखने के लिए क्लिक करें",
    "click_top_right": "ऊपर दाईं ओर क्लिक करें",
    "close": "बंद करना",
    "code_kopieren": "कोड कॉपी करें",
    "code_kopieren_success": "कोड कॉपी किया गया",
    "confirm_clear_channel_desc": "क्या आप इस चैनल को अपने स्थानीय दृश्य से साफ़ करना चाहते हैं?",
    "confirm_clear_channel_title": "खाली चैनल",
    "confirm_clear_chat": "क्या आप इस चैट को खाली करना चाहते हैं?",
    "confirm_clear_chat_desc": "क्या आप इस चैट को खाली करना चाहते हैं?",
    "confirm_clear_chat_title": "खाली चैट",
    "confirm_clear_everyone": "क्या आप दोनों भागीदारों के लिए चैट खाली करना चाहते हैं? (ठीक है = सभी के लिए, रद्द करें = सिर्फ मेरे लिए)",
    "confirm_delete_everyone": "क्या आप दोनों भागीदारों के लिए संदेश हटाना चाहते हैं? (ठीक है = सभी के लिए, रद्द करें = सिर्फ मेरे लिए)",
    "confirm_delete_msg": "क्या आप यह संदेश हटाना चाहते हैं?",
    "confirm_delete_msg_desc": "क्या आप इस चैट संदेश को हटाना चाहते हैं?",
    "confirm_delete_msg_title": "संदेश को हटाएं",
    "confirm_new_password": "नए पासवर्ड की पुष्टि करें",
    "copy": "प्रतिलिपि",
    "create_btn": "बनाएं",
    "create_channel_title": "चैनल बनाएं",
    "create_group_is_crisis": "संकटग्रस्त क्षेत्र के रूप में चिह्नित करें",
    "create_group_title": "नया समूह बनाएं",
    "crypto_lock_desc": "यह नियंत्रित करता है कि GaiaCOM मेमोरी से स्थानीय क्रिप्टो कुंजियाँ कब हटाता है।",
    "crypto_lock_menu_desc": "पुनः लोड और निष्क्रियता टाइमर को नियंत्रित करें।",
    "crypto_lock_title": "क्रिप्टोग्राफ़िक लॉक",
    "crypto_session_duration": "पुनः लोड करने के बाद अनलॉक किया गया",
    "crypto_session_duration_desc": "इस ब्राउज़र टैब में क्रिप्टो सत्र को केवल चयनित अवधि के लिए खुला रखता है।",
    "cryptographic_fingerprint": "क्रिप्टोग्राफ़िक फ़िंगरप्रिंट",
    "current_password": "वर्तमान पासवर्ड",
    "data_minimization": "डेटा न्यूनीकरण",
    "decrypt_failed": "समझने योग्य नहीं",
    "delete": "मिटाना",
    "delete_account_button": "खाते को अपरिवर्तनीय रूप से हटाएँ",
    "delete_account_confirm_label": "पुष्टि करने के लिए DELETE दर्ज करें",
    "delete_account_confirmation_error": "पासवर्ड और DELETE पुष्टिकरण आवश्यक है।",
    "delete_account_desc": "यह मोड आपके खाते, पहचान, डिवाइस सत्र, गैयाड्रॉप डेटा, अपलोड मेटाडेटा और सर्वर-साइड जिम्मेदार संदेशों को स्थायी रूप से नष्ट कर देता है।",
    "delete_account_done_desc": "सभी असाइन करने योग्य GaiaCOM डेटा हटा दिया गया है।",
    "delete_account_done_title": "खाता हटा दिया गया",
    "delete_account_menu_desc": "खाता और संबंधित डेटा नष्ट करें.",
    "delete_account_not_authenticated": "कोई सक्रिय खाता नहीं.",
    "delete_account_title": "खाता हटा दो",
    "delete_for_everyone": "सभी के लिए हटाएँ",
    "delete_for_me": "केवल मेरे लिए हटाएं",
    "device_current": "यह डिवाइस",
    "device_last_seen": "अंतिम",
    "device_logout": "लॉग आउट",
    "device_sessions_desc": "सक्रिय सत्रों की जाँच करें और उन डिवाइसों का पंजीकरण रद्द करें जिन पर अब आपको भरोसा नहीं है।",
    "device_sessions_empty": "कोई यंत्र नहीं मिले।",
    "device_sessions_menu_desc": "सक्रिय सत्र प्रबंधित करें और समाप्त करें.",
    "device_sessions_title": "पंजीकृत उपकरण",
    "device_since": "तब से",
    "display_name": "प्रदर्शित होने वाला नाम",
    "drop_address_copied": "गैयाड्रॉप पता कॉपी किया गया।",
    "drop_btn_decrypting": "इनबॉक्स को डिक्रिप्ट किया जा रहा है...",
    "drop_btn_load": "गैयाड्रॉप इनबॉक्स लोड करें",
    "drop_delete_desc": "क्या आप सचमुच इस ड्रॉप को स्थायी रूप से हटाना चाहते हैं?",
    "drop_delete_title": "गैयाड्रॉप हटाएं",
    "drop_desc": "बाहरी नोटिस, जिम्मेदार प्रकटीकरण और गोपनीय रिपोर्ट के लिए केवल टेक्स्ट शून्य-ज्ञान ड्रॉप चैनल। बाहरी पार्टियाँ आपके GaiaID का उपयोग करके बिना किसी खाते के संदेश भेज सकती हैं।",
    "drop_empty": "अभी तक कोई GaiaDrop संदेश लोड नहीं हुआ है.",
    "drop_id": "ड्रॉप आईडी:",
    "drop_own_address": "आपका गैयाड्रॉप पता",
    "drop_proof": "ड्रॉप प्रूफ",
    "drop_title": "गैयाड्रॉप सिक्योर इनबॉक्स",
    "dunkler_modus": "डार्क मोड",
    "e2e_chat_room_open": "E2E चैट रूम खोलें",
    "edit_profile": "प्रोफ़ाइल संपादित करें",
    "edit_profile_desc": "प्रदर्शन नाम, जीवनी और अवतार को अनुकूलित करें।",
    "einladungscode": "आमंत्रण कोड",
    "enter_fingerprint_chars_confirm": "पुष्टि करने के लिए अनुरोधित फ़िंगरप्रिंट वर्ण दर्ज करें।",
    "envelope_hash": "लिफाफा हैश",
    "erasability": "erasability",
    "erfolg": "सफलता",
    "exclude_plaintext": "सादे पाठ के बिना निर्यात करें",
    "export_disclosure": "निर्यात सुरक्षा मामला",
    "export_package_desc": "यदि यह प्रकटीकरण जानबूझकर किया गया है तो केवल सादा पाठ शामिल करें।",
    "export_package_title": "सुरक्षा पैकेज निर्यात करें",
    "fehler": "गलती",
    "gaiacom_reader": "गैयाकॉम रीडर",
    "gaiadrop_inbox_title": "गैयाड्रॉप इनबॉक्स",
    "gaiavault": "गैयावॉल्ट",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM मेटाडेटा को न्यूनतम करता है, निजी कुंजी को स्थानीय रखता है, सामग्री को शुरू से अंत तक एन्क्रिप्ट करता है और पूर्ण खाता हटाने में सक्षम बनाता है।",
    "gdpr_home_title": "100% जीडीपीआर अनुरूप",
    "gdpr_reason_delete": "खाता हटाने से खाता, पहचान, स्थानीय सत्र और सर्वर-साइड असाइन करने योग्य डेटा हटा दिया जाता है।",
    "gdpr_reason_e2ee": "निजी सामग्री केवल इच्छित प्राप्तकर्ताओं के लिए डिक्रिप्ट योग्य रहती है।",
    "gdpr_reason_minimal": "मेटाडेटा का उपयोग केवल रूटिंग, डिलीवरी और सुरक्षा क्रेडेंशियल के लिए किया जाता है।",
    "gdpr_reason_zero_knowledge": "निजी कुंजियाँ और पुनर्प्राप्ति डेटा स्थानीय रूप से उपयोगकर्ता के नियंत्रण में रहते हैं।",
    "gesendet": "भेजा",
    "gesperrt_verdaechtig": "प्रतिबंधित/संदिग्ध",
    "group_delete_desc": "क्या आप सचमुच इस समूह को स्थायी रूप से हटाना चाहते हैं? इस समूह के सभी चैनल और संदेश हटा दिए जाएंगे.",
    "group_delete_title": "समूह हटाएँ",
    "group_description": "विवरण",
    "group_icon_label": "समूह चिह्न/अवतार",
    "group_name": "समूह नाम",
    "group_settings_avatar": "अवतार",
    "group_settings_desc": "विवरण",
    "group_settings_is_crisis": "संकटग्रस्त क्षेत्र के रूप में चिह्नित करें",
    "group_settings_name": "समूह नाम",
    "group_settings_title": "समूह सेटिंग",
    "groups_empty_desc": "परियोजना, संकट या टीम संचार के लिए एक सुरक्षित कार्यक्षेत्र बनाएं।",
    "groups_empty_title": "अभी तक कोई समूह चैट नहीं",
    "gruppe_beitreten": "समूह में शामिल हो गए",
    "gruppe_erstellen": "+ समूह बनाएँ",
    "gruppe_verlassen": "समूह छोड़ें",
    "gruppen_chats": "समूह चैट",
    "heller_modus": "उज्ज्वल मोड",
    "how_to_receive_drops": "मुझे बूँदें कैसे प्राप्त होंगी?",
    "identitaets_assistent": "पहचान सहायक",
    "inactivity_lock_duration": "निष्क्रिय होने पर लॉक करें",
    "inactivity_lock_duration_desc": "बिना किसी इनपुट की इस अवधि के बाद, GaiaCOM स्वचालित रूप से क्रिप्टोग्राफ़िक रूप से लॉक हो जाएगा।",
    "inactivity_lock_notice": "निष्क्रियता के कारण GaiaCOM को क्रिप्टोग्राफ़िक रूप से अवरुद्ध कर दिया गया है।",
    "include_plaintext": "सादा पाठ शामिल करें",
    "invite_code_label": "आमंत्रण कोड",
    "join_group_title": "समूह में शामिल",
    "kanaele": "चैनल",
    "kanal_erstellen": "+ चैनल",
    "kein_chat_ausgewaehlt": "कोई चैट चयनित नहीं",
    "kein_kanal_ausgewaehlt": "कोई चैनल चयनित नहीं",
    "keine_gruppe_ausgewaehlt": "कोई समूह चयनित नहीं",
    "keine_mails": "कोई ईमेल उपलब्ध नहीं.",
    "key_change_warn_desc": "इस संपर्क की सार्वजनिक कुंजी बदल गई है. इस पर भरोसा करने से पहले फिंगरप्रिंट की जांच कर लें.",
    "key_change_warn_title": "क्रिप्टोग्राफ़िक चेतावनी",
    "key_change_warning_changed": "बदल गया है। यह बीच-बीच में किसी व्यक्ति द्वारा किए गए हमले का संकेत हो सकता है!",
    "key_change_warning_msg": "संपर्क के लिए पहचान कुंजी",
    "key_transparency": "मुख्य पारदर्शिता",
    "kopiert": "कॉपी किया गया",
    "kryptographische_schluessel": "क्रिप्टोग्राफ़िक कुंजियाँ",
    "kryptographische_schluessel_desc": "निजी कुंजियाँ और बैकअप बीज वाक्यांश दिखाएँ।",
    "laden": "भार...",
    "leeren": "खाली",
    "loading": "भार...",
    "local_key_vault": "स्थानीय कुंजी वॉल्ट",
    "local_keys_label": "स्थानीय कुंजियाँ",
    "lock_on_reload": "पुनः लोड करने के बाद हमेशा लॉक करें",
    "logout": "लॉग आउट",
    "mail_compose": "ईमेल लिखें",
    "mein_profil": "मेरी प्रोफाइल",
    "melden": "प्रतिवेदन",
    "menu": "मेनू",
    "message": "समाचार",
    "message_id": "संदेश आईडी",
    "message_pin": "नत्थी करना",
    "message_pinned_title": "पिन किए गए संदेश",
    "message_react": "प्रतिक्रिया",
    "message_reply": "उत्तर",
    "message_replying_to": "को उत्तर",
    "message_save": "बचाना",
    "message_saved": "सहेजा गया",
    "message_to_channel": "को संदेश",
    "message_unpin": "हल करना",
    "message_unsave": "बचाओ मत",
    "mitglied": "सदस्य",
    "mitglieder": "सदस्यों",
    "ml_kem": "एमएल-केईएम",
    "neue_mail": "नया ईमेल",
    "never_auto_lock": "स्वचालित रूप से कभी नहीं",
    "new_fingerprint": "नया फ़िंगरप्रिंट",
    "new_identity": "नई पहचान",
    "new_password": "नया पासवर्ड",
    "no_description": "कोई विवरण नहीं",
    "no_key_history": "कोई प्रमुख इतिहास दर्ज नहीं किया गया.",
    "no_specification": "निर्दिष्ट नहीं है",
    "old_fingerprint": "पुराना फ़िंगरप्रिंट",
    "open_privacy_imprint": "खुली छाप और डेटा सुरक्षा",
    "post_quantum_e2e": "पोस्ट-क्वांटम E2E",
    "posteingang": "इनबॉक्स",
    "powered_by": "द्वारा संचालित",
    "privacy_imprint_menu_desc": "जीडीपीआर, डेटा सुरक्षा और कानूनी नोटिस दिखाएं।",
    "privacy_imprint_profile_desc": "GaiaCOM संचार सामग्री को डेटा न्यूनतमकरण, एंड-टू-एंड एन्क्रिप्शन और स्थानीय कुंजी नियंत्रण के सिद्धांतों के अनुसार संसाधित करता है।",
    "privacy_imprint_title": "डेटा सुरक्षा एवं कानूनी नोटिस",
    "profil": "प्रोफ़ाइल",
    "profile_details": "प्रोफ़ाइल विवरण",
    "profile_settings_hint": "प्रोफ़ाइल सेटिंग्स दाएँ पैनल में प्रदर्शित होती हैं।",
    "profile_unlock_desc": "सुरक्षा कारणों से, आपको अपनी निजी क्रिप्टोग्राफ़िक कुंजियाँ देखने के लिए अपना पासवर्ड दोबारा दर्ज करना होगा।",
    "proof_hash": "प्रमाण हैश:",
    "public_drop_desc": "गैयाकॉम खाते के बिना बाहरी पाठ जानकारी के लिए सुरक्षित ड्रॉप।",
    "public_drop_message": "समाचार",
    "public_drop_message_placeholder": "गोपनीय पाठ दर्ज करें...",
    "public_drop_send": "गैयाड्रॉप भेजें",
    "public_drop_sender": "प्रेषक नोट वैकल्पिक",
    "public_drop_sender_placeholder": "नाम, फ़ाइल नंबर या गुमनाम",
    "public_drop_target": "GaiaID को लक्ष्य करें",
    "quanten_chat": "क्वांटम चैट",
    "quantum_secure_exchange": "क्वांटम सुरक्षित विनिमय के माध्यम से...",
    "quantum_secure_net": "GaiaCOM क्वांटम सिक्योर नेटवर्क (Ed25519 और ML-KEM)",
    "quantum_shield_desc": "GaiaCOM नेटवर्क एक बहु-परत, हाइब्रिड एन्क्रिप्शन प्रोटोकॉल के साथ आपकी गोपनीयता की रक्षा करता है जो भविष्य के क्वांटम कंप्यूटरों के हमलों से सुरक्षित है।",
    "quantum_shield_l1_desc": "सममित साझा कुंजी को एनकैप्सुलेट करने के लिए FIPS 203 मानक का उपयोग करता है। क्वांटम कंप्यूटर द्वारा निष्क्रिय रिकॉर्डिंग और बाद में डिक्रिप्शन (\\",
    "quantum_shield_l1_title": "1. पोस्ट-क्वांटम सुरक्षा (ML-KEM-1024)",
    "quantum_shield_l2_desc": "एक क्लासिक, बेहद तेज़ डिफी-हेलमैन कुंजी विनिमय प्रक्रिया जो हाइब्रिड प्रक्रिया में सुरक्षा की एक अतिरिक्त परत के रूप में कार्य करती है।",
    "quantum_shield_l2_title": "2. अण्डाकार वक्र क्रिप्टोग्राफी (X25519)",
    "quantum_shield_l3_desc": "प्रेषक की प्रामाणिकता को स्पष्ट रूप से सत्यापित करने के लिए प्रत्येक संदेश और प्रत्येक फेडरेशन लिफाफे पर क्रिप्टोग्राफ़िक रूप से हस्ताक्षर किए जाते हैं।",
    "quantum_shield_l3_title": "3. डिजिटल हस्ताक्षर (Ed25519)",
    "quantum_shield_l4_desc": "संदेश सामग्री को सममित रूप से एन्क्रिप्ट करता है और रीप्ले हमलों को रोकने के लिए प्रेषक, प्राप्तकर्ता और मेटाडेटा को प्रमाणित अतिरिक्त डेटा (एएडी) में कसकर बांधता है।",
    "quantum_shield_l4_title": "4. एएडी प्रमाणीकरण (एईएस-256-जीसीएम)",
    "quantum_shield_status": "क्वांटम शील्ड स्थिति",
    "receive_drops_step1": "अपनी GaiaID को बाहरी स्रोतों के साथ साझा करें (उदाहरण के लिए ऊपर दिए गए कॉपी बटन का उपयोग करके)।",
    "receive_drops_step2": "ये आपके GaiaCOM इंस्टेंस के लॉगिन पेज को कॉल करते हैं और टैब पर स्विच करते हैं",
    "receive_drops_step3": "और उनका एन्क्रिप्टेड संदेश आपके पते पर भेजें।",
    "receiver_gaia": "गैयाकॉम रिसीवर",
    "receiver_smtp": "एसएमटीपी प्राप्तकर्ता",
    "records_stored": "रिकॉर्ड सहेजे गए",
    "refresh": "अद्यतन",
    "report_abuse_desc": "क्या आप इस संदेश की रिपोर्ट करना चाहते हैं और सर्वर पर दुरुपयोग के क्रिप्टोग्राफ़िक साक्ष्य जमा करना चाहते हैं?",
    "report_abuse_title": "दुरुपयोग होने की सूचना दें",
    "reputation_status": "प्रतिष्ठा स्थिति",
    "room_chat_start_hint": "बातचीत शुरू करें! इस समूह चैनल के सभी संदेश विकेंद्रीकृत क्वांटम-सुरक्षित E2E एन्क्रिप्टेड हैं।",
    "room_policy_audit": "ऑडिट ट्रेल और कुंजी रोटेशन सक्रिय।",
    "room_policy_crisis": "संकट कक्ष",
    "room_policy_e2ee": "शून्य-ज्ञान स्थान. E2EE क्वांटम सुरक्षित।",
    "room_policy_title": "कक्ष दिशानिर्देश",
    "room_policy_zero_knowledge": "नीति",
    "room_security_note_desc": "सभी प्रमुख परिवर्तन कुंजी पारदर्शिता के माध्यम से मान्य किए जाते हैं। निजी बैकअप लॉग के लिए GaiaVault का उपयोग करें।",
    "room_security_note_title": "पिन किया गया सुरक्षा नोट",
    "save_profile": "प्रोफ़ाइल बचा",
    "schluessel_entsperrt": "🔑 चाबी को फिर से लॉक करें",
    "search_gaia_label": "गैया का पता खोजें",
    "security_warning_title": "सुरक्षा चेतावनी",
    "select_channel_chat": "चैट करने के लिए बाएं साइडबार से एक चैनल चुनें।",
    "select_contact_chat": "क्वांटम-सुरक्षित E2E चैट शुरू करने के लिए बाएं पैनल से एक संपर्क चुनें।",
    "select_mail_read": "इसकी क्वांटम-सुरक्षित सामग्री को पढ़ने या एक नया संदेश बनाने के लिए सूची से एक ईमेल का चयन करें।",
    "senden": "भेजना",
    "sender_signature": "प्रेषक के हस्ताक्षर",
    "server_log": "सर्वर लॉग:",
    "server_received": "सर्वर प्राप्त हुआ",
    "session_lock": "सत्र ताला",
    "setup_address_keys": "पता और कुंजी सेट बनाएं",
    "setup_profile": "प्रोफ़ाइल में सेट करें",
    "smtp_inbox_title": "एसएमटीपी रिसेप्शन",
    "smtp_legacy_badge": "लीगेसी एसएमटीपी/असुरक्षित",
    "smtp_mode_option": "विरासत एसएमटीपी पुल",
    "smtp_security_warning": "यह ईमेल क्लासिक, अनएन्क्रिप्टेड एसएमटीपी प्रोटोकॉल के माध्यम से प्रेषित किया गया था। कोई एंड-टू-एंड एन्क्रिप्शन सक्रिय नहीं है.",
    "smtp_security_warning_desc": "यह संदेश GaiaCom सुरक्षा कक्ष से निकल रहा है। एसएमटीपी डिलीवरी GaiaCom की मूल एंड-टू-एंड गारंटी, कोई ट्रस्टमेश गारंटी और गेटवे से कोई गॉडमोड गारंटी प्रदान नहीं करती है।",
    "spam_verdacht": "स्पैम/संदेह",
    "spam_warning_desc": "इस संदेश में संदिग्ध प्रतिष्ठा संकेत हैं.",
    "spam_warning_title": "स्पैम चेतावनी",
    "speichern": "बचाना",
    "sperren": "ताला लगाओ",
    "standard_group_status": "मानक समूह चैट (E2EE एन्क्रिप्टेड)",
    "status": "स्थिति",
    "subject": "के बारे में",
    "suchen": "एक नया गैया पता खोजें...",
    "tage": "दिन",
    "time_unknown": "समय अज्ञात",
    "transmission_mode": "रीति का अंतरण करें",
    "trust_age": "उम्र पर भरोसा रखें",
    "trust_passport_title": "पासपोर्ट पर भरोसा करें",
    "unbestaetigt": "अपुष्ट",
    "unknown_sender": "अज्ञात",
    "unlock_btn": "अनलॉक",
    "unlock_btn_profile": "अनलॉक",
    "unlock_desc": "आपकी निजी कुंजी फ़ाइल एन्क्रिप्टेड संग्रहीत है। क्रिप्टोग्राफ़िक कुंजियों को केवल मेमोरी में लोड करने के लिए अपना पासवर्ड दर्ज करें।",
    "unlock_logout": "लॉग आउट करें और स्थानीय कुंजियाँ बंद करें",
    "unlock_title": "पहचान अनलॉक करें",
    "untrusted": "भरोसेमंद नहीं",
    "update_password": "पासवर्ड अपडेट करें",
    "upload_avatar_btn": "छवि अपलोड करें (स्वच्छतायुक्त)",
    "vault_btn_encrypt": "रिकॉर्ड एन्क्रिप्ट करें",
    "vault_btn_lock": "सुरक्षित ताला",
    "vault_btn_unlock": "सुरक्षित रूप से अनलॉक करें",
    "vault_copied_success": "क्लिपबोर्ड पर कॉपी किया गया",
    "vault_decrypted_content": "डिक्रिप्ट की गई सामग्री",
    "vault_desc": "पुनर्प्राप्ति बैकअप, पहचान नोट, सर्वर पहुंच, आपातकालीन संपर्क, कानूनी नोट्स, सुरक्षा घटनाओं और निजी लॉग के लिए स्थानीय एन्क्रिप्टेड वॉल्ट।",
    "vault_empty": "अभी तक कोई सुरक्षित रिकॉर्ड सहेजा नहीं गया.",
    "vault_locked_pane_notice": "तिजोरी बंद है. कृपया दाईं ओर अनलॉक करें.",
    "vault_new_record": "नया सुरक्षित रिकॉर्ड",
    "vault_pwd_placeholder": "वॉल्ट पासवर्ड दर्ज करें...",
    "vault_record_body": "सामग्री रिकॉर्ड करें",
    "vault_record_body_placeholder": "एन्क्रिप्टेड रिकॉर्ड सामग्री दर्ज करें...",
    "vault_record_category": "वर्ग",
    "vault_record_title": "रिकॉर्ड शीर्षक",
    "vault_record_title_placeholder": "सुरक्षित रिकॉर्ड का शीर्षक",
    "vault_title": "गैयावॉल्ट सिक्योर रिकॉर्ड्स",
    "verify_new_fingerprint_hint": "कुंजी स्वीकार करने से पहले नए फ़िंगरप्रिंट की जाँच करें।",
    "vertrauenswuerdig": "भरोसेमंद",
    "vision_gaia_technology": "विज़नगैया टेक्नोलॉजी",
    "von": "से",
    "warnung": "चेतावनी",
    "wizard_address": "पता",
    "wizard_back": "पीछे",
    "wizard_check1": "मैंने अपना बीज सुरक्षित रख लिया है.",
    "wizard_custom_domain": "अपने स्वयं के डोमेन का उपयोग करें",
    "wizard_desc1": "GaiaCOM सर्वर साइड पर निजी कुंजी संग्रहीत नहीं करता है। निमोनिक सीड के बिना, कोई भी खोए हुए संदेशों को पुनर्प्राप्त नहीं कर सकता है।",
    "wizard_desc2": "आपका पता फ़ेडरेटेड नोड निर्धारित करता है जिसके माध्यम से एन्क्रिप्टेड लिफ़ाफ़े रूट किए जाते हैं।",
    "wizard_fallback": "फ़ॉलबैक नोड्स",
    "wizard_finish": "पूरा सेटअप",
    "wizard_next": "आगे",
    "wizard_server_domain": "सर्वर नोड डोमेन",
    "wizard_step1": "1. बैकअप बीज",
    "wizard_step2": "2. पता एवं सर्वर",
    "wizard_title1": "पुनर्प्राप्ति कुंजी का बैकअप लें",
    "wizard_title2": "GaiaCOM पता चुनें",
    "write_message_placeholder": "एक सुरक्षित संदेश लिखें...",
    "you": "आप",
    "zero_knowledge": "शून्य ज्ञान",
    "zero_knowledge_encryption": "शून्य-ज्ञान एन्क्रिप्शन",
    "Chat fuer alle geleert": "Der Chat wurde für alle Teilnehmer geleert.",
    "Chat geleert": "Der Chat wurde für deine lokale Inbox geleert.",
    "Nachricht fuer alle geloescht": "Die Nachricht wurde für alle Teilnehmer gelöscht.",
    "Nachricht geloescht": "चैट संदेश आपके इनबॉक्स से स्थानीय रूप से हटा दिया गया है।",
    "anpinnen": "Anpinnen",
    "chat_loeschen": "Chat löschen",
    "confirm_delete_chat_desc": "Möchtest du den Chat wirklich löschen und ausblenden?",
    "confirm_leave_group_desc": "Möchtest du diese Gruppe wirklich verlassen?",
    "entpinnen": "Entpinnen",
    "group_deleted": "Gruppe erfolgreich gelöscht.",
    "group_left": "Gruppe erfolgreich verlassen.",
    "gruppe_loeschen": "Gruppe löschen",
    "loeschen": "Löschen",
    "no_active_chats": "Keine aktiven Chats. Suche oben nach Kontakten, um einen Chat zu starten.",
    "pinned": "Angepinnt",
    "wizard_check_credentials": "मैं अपने एक्सेस डेटा को सुरक्षित रखने के लिए जिम्मेदार हूं।",
    "wizard_check_is_beta": "मैं समझता हूं कि GaiaCom बीटा सॉफ़्टवेयर है।",
    "wizard_check_no_illegal": "मैं गैयाकॉम का उपयोग गैरकानूनी उद्देश्यों के लिए नहीं करूंगा।",
    "wizard_check_no_uptime": "मैं समझता हूं कि उपलब्धता की कोई गारंटी नहीं है।",
    "wizard_check_smtp_security": "मैं समझता हूं कि एसएमटीपी संदेश पूर्ण GaiaCom सुरक्षा प्रदान नहीं करते हैं।",
    "wizard_check_terms_read": "मैंने सेवा की बीटा शर्तें पढ़ ली हैं.",
    "wizard_step_terms": "उपयोग की शर्तें",
    "wizard_terms_text": "गैयाकॉम उपयोग की शर्तें और बीटा परीक्षण समझौता (बीटा चरण)\n\nप्रदाता: VisionGaiaTechnology (इसके बाद \"प्रदाता\" के रूप में संदर्भित)\nस्थिति: सार्वजनिक बीटा परीक्षण चरण\nवैधता: 21 जून 2026 से\n\n⚠️ अग्रिम में सबसे महत्वपूर्ण नोट (कृपया ध्यान से पढ़ें)\nGaiaCom सार्वजनिक बीटा परीक्षण चरण में है। व्यापक सुरक्षा उपायों के बावजूद, त्रुटियों से मुक्ति, सॉफ़्टवेयर और अंतर्निहित बुनियादी ढांचे की निरंतर उपलब्धता या पूर्ण सुरक्षा की गारंटी नहीं दी जा सकती है। अपने जोखिम पर उपयोग करें। उपयोगकर्ता अपने एक्सेस डेटा (विशेष रूप से गैयावॉल्ट के लिए कुंजी) के सुरक्षित भंडारण और लागू कानूनों के अनुपालन के लिए जिम्मेदार हैं।\n\n1. बीटा परीक्षण चरण का विषय और उद्देश्य\n1.1. प्रावधान का उद्देश्य: GaiaCom पोस्ट-क्वांटम क्रिप्टोग्राफी (PQC) पर आधारित एक नवीन ईमेल और चैट सेवा है। बीटा चरण के दौरान प्रावधान विशेष रूप से तकनीकी परीक्षण, लोड सिमुलेशन, प्रोग्राम त्रुटियों (बग) को खोजने और उपयोगकर्ता-मित्रता को अनुकूलित करने के लिए है।\n1.2. बीटा स्थिति: उपयोगकर्ता को पता है कि पेश किया गया सॉफ़्टवेयर प्रारंभिक संस्करण (बीटा सॉफ़्टवेयर) है। यह अभी तक तकनीकी रूप से पूरी तरह से विकसित नहीं हुआ है, अंतिम, वाणिज्यिक उत्पाद के मानक को पूरा नहीं करता है और त्रुटियों, डेटा हानि, ट्रांसमिशन देरी या सिस्टम क्रैश का कारण बन सकता है।\n1.3. जारी रखने का कोई अधिकार नहीं: प्रदाता किसी भी समय सेवा को पूर्ण या आंशिक रूप से बंद करने, कार्यों को बदलने या प्रतिबंधित करने या उन्हें बिना कारण बताए अस्थायी या स्थायी रूप से हटाने का हकदार है।\n\n2. वारंटी की उपलब्धता और अस्वीकरण\n2.1. उपलब्धता की कोई गारंटी नहीं: GaiaCom उपलब्धता या अपटाइम की किसी गारंटी के बिना प्रदान किया जाता है। सेवा की निर्बाध उपलब्धता का कोई अधिकार नहीं है.\n2.2. वारंटी का बहिष्करण: सॉफ़्टवेयर अपनी वर्तमान स्थिति (\"जैसा है\") और उपलब्धता के अधीन प्रदान किया जाता है। कानून द्वारा अनुमत सीमा तक, सॉफ़्टवेयर में सामग्री और कानूनी दोषों के लिए किसी भी वारंटी दावे को बाहर रखा गया है। विशेष रूप से, इस बात की कोई गारंटी नहीं है कि सॉफ़्टवेयर त्रुटि-मुक्त है, मैलवेयर से मुक्त है या किसी विशेष उद्देश्य के लिए उपयुक्त है।\n\n3. जोखिम प्रबंधन और उपयोगकर्ता दायित्व\n3.1. महत्वपूर्ण डेटा के भंडारण पर प्रतिबंध: उपयोगकर्ता GaiaCom के माध्यम से किसी भी व्यवसाय-महत्वपूर्ण, महत्वपूर्ण, परिचालन रूप से आवश्यक या कानूनी रूप से विशेष रूप से संवेदनशील डेटा (जैसे रोगी फ़ाइलें, अत्यधिक संवेदनशील वित्तीय डेटा या आधिकारिक तौर पर विनियमित रहस्य) को विशेष रूप से संग्रहीत या प्रसारित नहीं करने का वचन देता है। इस सेवा का उपयोग बुनियादी ढांचे के लिए नहीं किया जा सकता है जहां अप्रत्याशित विफलताओं के परिणामस्वरूप व्यक्तिगत चोट, संपत्ति की क्षति या महत्वपूर्ण वित्तीय हानि हो सकती है।\n3.2. स्व-जिम्मेदार बैकअप: उपयोगकर्ता गैयाकॉम के माध्यम से प्राप्त या भेजे गए सभी डेटा का बैकअप लेने के लिए जिम्मेदार है, जिसकी उसे लंबी अवधि में अपने स्वतंत्र सिस्टम (बैकअप प्रतियां) पर आवश्यकता होती है। प्रदाता अपने सर्वर पर डेटा के स्थायी भंडारण या पुनर्स्थापना की गारंटी नहीं देता है।\n\n4. क्रिप्टोग्राफ़िक सुविधाएँ और गैयावॉल्ट\n4.1. पोस्ट-क्वांटम क्रिप्टोग्राफी (पीक्यूसी): गैयाकॉम अत्याधुनिक, भविष्य-उन्मुख एन्क्रिप्शन प्रक्रियाओं को लागू करता है जो भविष्य के क्वांटम कंप्यूटरों से हमलों का सामना करने के लिए डिज़ाइन किए गए हैं। हालाँकि, उपयोगकर्ता जानता है कि यह एक गतिशील और नया वैज्ञानिक क्षेत्र है। विज्ञान और प्रौद्योगिकी की वर्तमान स्थिति के आधार पर पूर्ण, अकाट्य सुरक्षा की गारंटी नहीं दी जा सकती। \"100% सुरक्षित\", \"अनक्रैकेबल\" या \"सैन्य सुरक्षित\" जैसे शब्दों की स्पष्ट रूप से गारंटी नहीं है।\n4.2. कोई पुनर्प्राप्ति गारंटी नहीं (GaiaVault): GaiaCom लगातार शून्य-ज्ञान सुरक्षा अवधारणा पर निर्भर करता है। एन्क्रिप्शन वेजेज और एक्सेस डेटा पूरी तरह से उपयोगकर्ता के नियंत्रण में रहता है (GaiaVault के माध्यम से सुरक्षित)।\nमहत्वपूर्ण: यदि उपयोगकर्ता अपने पासवर्ड, पासफ़्रेज़, निजी कुंजी या पुनर्प्राप्ति बीज खो देता है, तो प्रदाता के पास इस डेटा को पुनर्निर्माण या रीसेट करने की कोई तकनीकी क्षमता नहीं है। इन एक्सेस डेटा के खोने से अनिवार्य रूप से उपयोगकर्ता खाते और उसमें एन्क्रिप्ट किए गए सभी डेटा तक पहुंच की अपरिवर्तनीय हानि होती है।\n4.3. अभी तक पूरी तरह से ऑडिट नहीं किया गया है: सॉफ़्टवेयर को लगातार आंतरिक सुरक्षा जांच के अधीन किया जाता है, लेकिन इस बीटा चरण के समय यह अभी तक स्वतंत्र परीक्षण निकायों द्वारा अंतिम, व्यापक बाहरी सुरक्षा ऑडिट से नहीं गुजरा है।\n\n5. इंटरफेस, लीगेसी प्रोटोकॉल और फेडरेशन\n5.1. एसएमटीपी ब्रिज नोट: गैयाकॉम क्लासिक ईमेल प्रोटोकॉल (जैसे एसएमटीपी) के माध्यम से संचार करने की क्षमता प्रदान करता है। उपयोगकर्ता को पता है कि जो संदेश मूल GaiaCom सुरक्षा क्षेत्र को छोड़ते हैं (उदाहरण के लिए जब पारंपरिक @gmail.com या @gmx.de पते पर भेजे जाते हैं) अनएन्क्रिप्टेड या तृतीय-पक्ष सर्वर के माध्यम से भेजे जाते हैं। GaiaCom की एंड-टू-एंड सुरक्षा गारंटी केवल एक सीमित सीमा तक ही लागू होती है या ऐसे आउटगोइंग या बाहरी रूप से आने वाले विरासत संदेशों पर बिल्कुल भी लागू नहीं होती है।\n5.2. फ़ेडरेशन नोट: यदि GaiaCom फ़ेडरेटेड नेटवर्क पर काम करता है, तो संदेश और डेटा तृतीय-पक्ष सर्वर से गुज़र सकते हैं। जबकि संदेशों की सामग्री एंड-टू-एंड एन्क्रिप्शन द्वारा संरक्षित रहती है, मेटाडेटा (जैसे भेजने का समय, शामिल सर्वर के आईपी पते और प्राप्तकर्ता पते) तकनीकी रूप से इन फ़ेडरेटेड सर्वर के ऑपरेटरों को दिखाई दे सकते हैं। फ़ेडरेटेड नेटवर्क में तृतीय-पक्ष सर्वर ऑपरेटरों की डेटा सुरक्षा प्रथाओं पर प्रदाता का कोई प्रभाव नहीं है।\n\n6. स्वीकार्य उपयोग और निषिद्ध गतिविधियाँ\nउपयोगकर्ता यह वचन देता है कि वह सेवा का अनुचित तरीके से या अवैध उद्देश्यों के लिए उपयोग नहीं करेगा। विशेष रूप से, निम्नलिखित निषिद्ध हैं:\n- वायरस, मैलवेयर, फ़िशिंग सामग्री या अन्य दुर्भावनापूर्ण सॉफ़्टवेयर वितरित करना, भेजना या होस्ट करना।\n- सेवा से इनकार करने वाले हमलों (डीडीओएस) या अवांछित बल्क मेलिंग (स्पैम) का संचालन करने के लिए सेवा का उपयोग करना।\n- धोखाधड़ी करने के लिए सिस्टम का दुरुपयोग करना।\n- अवैध सामग्री का वितरण या आदान-प्रदान, विशेष रूप से बाल यौन शोषण (सीएसएएम), आतंकवादी प्रचार, हिंसा का आह्वान या अन्य आपराधिक रूप से प्रासंगिक सामग्री का चित्रण।\n\n7. दुरुपयोग रिपोर्टिंग प्रणाली\n7.1. अपमानजनक व्यवहार की रिपोर्ट करना: उपयोगकर्ताओं के पास एकीकृत दुर्व्यवहार प्रणाली के माध्यम से अपमानजनक संचार या अवैध गतिविधियों की रिपोर्ट करने का अवसर है।\n7.2. रिपोर्ट का प्रसंस्करण: दुरुपयोग के खिलाफ सुरक्षा सुनिश्चित करने के लिए, आने वाली रिपोर्ट का तकनीकी रूप से विश्लेषण किया जा सकता है (गोपनीयता और एन्क्रिप्शन सीमा बनाए रखते हुए)। इससे उपयोग की इन शर्तों के सिद्ध उल्लंघन की स्थिति में उपयोगकर्ता खातों या आईपी पते को अस्थायी या स्थायी रूप से निलंबित किया जा सकता है।\n\n8. दायित्व की सीमा\n8.1. दायित्व का मानक: बीटा सॉफ़्टवेयर निःशुल्क प्रदान किया जाता है। दान या ऋण के कानूनी नियमों के अनुसार, प्रदाता केवल इरादे (जानबूझकर क्षति) और घोर लापरवाही के लिए उत्तरदायी है।\n8.2. डेटा हानि के लिए दायित्व का बहिष्कार: डेटा की हानि के लिए दायित्व को तब तक बाहर रखा जाता है जब तक कि हानि जानबूझकर या प्रदाता द्वारा घोर लापरवाही के कारण नहीं हुई हो और उपयोगकर्ता ने नियमित बैकअप (GaiaCom के बाहर) के माध्यम से क्षति को कम करने के अपने दायित्व को पूरा किया हो।\n8.3. कानूनी सीमाएँ: उपरोक्त दायित्व सीमाएँ जीवन, शरीर या स्वास्थ्य पर चोट या उत्पाद दायित्व अधिनियम के तहत दायित्व पर लागू नहीं होती हैं।\n\n9. खुला स्रोत\nकुछ गैयाकॉम घटकों, पुस्तकालयों या क्लाइंट अनुप्रयोगों को ओपन सोर्स लाइसेंस (जैसे जीपीएल, एमआईटी, अपाचे) के तहत लाइसेंस दिया जा सकता है। इन घटकों की संबंधित लाइसेंस शर्तें उपयोग की इन शर्तों से अप्रभावित रहती हैं और इन्हें संबंधित स्रोत कोड रिपॉजिटरी में देखा जा सकता है।\n\n10. निर्यात नियंत्रण और अनुपालन\nउपयोगकर्ता को पता है कि क्रिप्टोग्राफ़िक सॉफ़्टवेयर सख्त निर्यात नियंत्रण और कानूनी प्रतिबंधों के अधीन हो सकता है। उपयोगकर्ता यह सुनिश्चित करने के लिए ज़िम्मेदार है कि GaiaCom का उपयोग उनके संबंधित देश के कानूनों, आयात/निर्यात प्रतिबंधों या क्रिप्टोग्राफी नियमों का उल्लंघन नहीं करता है।\n\n11. डेटा सुरक्षा सूचना (बीटा के लिए लघु संस्करण)\n11.1. न्यूनतम डेटा संग्रह: बीटा चरण के भाग के रूप में, प्रदाता केवल वह डेटा एकत्र करता है जो तकनीकी संचालन, समस्या निवारण और आगे के विकास के लिए बिल्कुल आवश्यक है (उदाहरण के लिए त्रुटि निदान के लिए सर्वर लॉग फ़ाइलें)।\n11.2. सामग्री के बारे में कोई जानकारी नहीं: निरंतर शून्य-ज्ञान और E2E एन्क्रिप्शन के लिए धन्यवाद, प्रदाता के पास GaiaVault में संग्रहीत आपकी चैट, ईमेल या कुंजियों की सामग्री तक कभी पहुंच नहीं होती है।\n11.3. विस्तृत डेटा सुरक्षा घोषणा: विस्तृत डेटा सुरक्षा नियम अलग से जुड़े हुए हैं और पंजीकरण से पहले उपयोगकर्ता द्वारा इसे भी ध्यान में रखा जाना चाहिए।\n\n12. अंतिम प्रावधान\n12.1. लागू कानून: माल की अंतर्राष्ट्रीय बिक्री के लिए अनुबंधों पर संयुक्त राष्ट्र कन्वेंशन को छोड़कर, जर्मनी के संघीय गणराज्य का कानून लागू होता है।\n12.2. परिवर्तन के अधीन: चूँकि GaiaCom सक्रिय विकास में है, प्रदाता भविष्य के लिए किसी भी समय इन स्थितियों को अनुकूलित करने का अधिकार सुरक्षित रखता है। वर्तमान संस्करण एप्लिकेशन में उपलब्ध है.",
    "wizard_terms_title": "गैयाकॉम उपयोग की शर्तें और बीटा परीक्षण समझौता (बीटा चरण)",
    "node_operator": "नोड ऑपरेटर",
    "search_channels": "चैनल खोजें...",
    "senior_reviewer": "वरिष्ठ समीक्षक",
    "trusted_reviewer": "विश्वसनीय समीक्षक",
    "active_frequencies": "सक्रिय आवृत्तियाँ",
    "connected_rooms": "जुड़े हुए स्थान",
    "dashboard": "डैशबोर्ड",
    "empty_chats": "कोई सक्रिय चैट उपलब्ध नहीं है.",
    "empty_messages": "कोई नया संदेश उपलब्ध नहीं है.",
    "encrypted": "कूट रूप दिया गया",
    "gaiacom_uplink": "गैयाकॉम अपलिंक",
    "install_app": "एप्लिकेशन इंस्टॉल करो",
    "install_app_desc": "त्वरित शुरुआत और ऑफ़लाइन मोड के लिए",
    "kommandozentrale_alpha": "अल्फा कमांड सेंटर",
    "network_online": "नेटवर्क: ऑनलाइन",
    "new_room": "नई जगह",
    "no_frequencies_active": "कोई फ़्रीक्वेंसी सक्रिय नहीं. संचार शुरू करने के लिए एक नया कमरा बनाएं.",
    "no_id": "कोई आईडी नहीं",
    "open_chats": "चैट खोलें",
    "open_inbox": "इनबॉक्स खोलें",
    "primary_identity": "प्राथमिक पहचान",
    "recent_chats": "नई चैट",
    "recent_messages": "ताजा खबर",
    "session_encrypted": "सत्र एन्क्रिप्टेड: {नाम}",
    "session_secure": "स्थिति: सुरक्षित",
    "system_verlassen": "निकास प्रणाली",
    "write_message": "एक सन्देश लिखिए",
    "onboarding_step_profile": "प्रोफ़ाइल",
    "onboarding_step_security": "सुरक्षा",
    "onboarding_step_backup": "बैकअप",
    "onboarding_step_launch": "शुरू करें",
    "onboarding_loading_gaia_id": "गया-आईडी लोड हो रहा है",
    "onboarding_setup_kicker": "गायाकॉम प्रारंभिक सेटअप",
    "onboarding_profile_title": "गायाकॉम को अपना स्थान बनाएं।",
    "onboarding_profile_desc": "आपका प्रदर्शित नाम और अवतार स्थानीय स्तर पर नियंत्रित रहते हैं और बाद में किसी भी समय प्रोफ़ाइल में बदले जा सकते हैं।",
    "onboarding_security_title": "गायाकॉम अभी आपकी क्या सुरक्षा कर रहा है।",
    "onboarding_security_desc": "गायाकॉम पहचान, चाबियाँ, संदेश और नेटवर्क स्थिति को अलग करता है। आप यहाँ केवल लघु उपयोगकर्ता संस्करण देखते हैं।",
    "onboarding_backup_title": "एक बैकअप आपका असली आपातकालीन निकास है।",
    "onboarding_backup_desc": "पुनर्प्राप्ति डेटा के बिना कोई भी आपकी पहचान नहीं बचा सकता है। वास्तविक एंड-टू-एंड सुरक्षा का यही मुख्य बिंदु है।",
    "onboarding_launch_title": "तैयार। आप सबसे पहले क्या करना चाहते हैं?",
    "onboarding_launch_desc": "आप सीधे शुरू कर सकते हैं या दौरे को समाप्त करके डैशबोर्ड में काम जारी रख सकते हैं।",
    "onboarding_display_name": "प्रदर्शित नाम",
    "onboarding_display_name_placeholder": "गायाकॉम आपको कैसे प्रदर्शित करे?",
    "onboarding_select_avatar": "अवतार चुनें",
    "onboarding_sec_identity_title": "पहचान",
    "onboarding_sec_identity_desc": "आपकी गया-आईडी आपका नेटवर्क एंकर है। संपर्क कुंजी परिवर्तन का पता लगा सकते हैं।",
    "onboarding_sec_messages_title": "संदेश",
    "onboarding_sec_messages_desc": "सामग्री स्थानीय रूप से डिक्रिप्ट की जाती है। संपादित संदेशों को नए हस्ताक्षर मिलते हैं।",
    "onboarding_sec_network_title": "नेटवर्क",
    "onboarding_sec_network_desc": "सुरक्षा केंद्र और दुरुपयोग केंद्र बिना किसी वैश्विक पिछले दरवाजे के जोखिमों को दृश्यमान बनाते हैं।",
    "onboarding_sec_transparency_title": "पारदर्शिता",
    "onboarding_sec_transparency_desc": "सुरक्षा-प्रासंगिक घटनाओं को लॉग में लिखता है ताकि चेतावनियाँ ट्रैक करने योग्य रहें।",
    "onboarding_backup_notice_title": "सामान्य उपयोगकर्ताओं के लिए महत्वपूर्ण",
    "onboarding_backup_notice_desc": "अपना पुनर्प्राप्ति डेटा इस डिवाइस से अलग सहेजें। पासवर्ड और बैकअप खो जाने की स्थिति में, गयाकॉम जानबूझकर बंद रहेगा।",
    "onboarding_backup_consent": "मुझे पता है कि मेरा बैकअप पुनर्प्राप्ति और डिवाइस बदलने के लिए महत्वपूर्ण है।",
    "onboarding_inbox_title": "इनबॉक्स",
    "onboarding_inbox_desc": "मेल पढ़ें और अपना पहला संदेश लिखें।",
    "onboarding_contacts_title": "संपर्क",
    "onboarding_contacts_desc": "पहले संपर्क की जांच करें या चैट शुरू करें।",
    "onboarding_channels_title": "चैनल",
    "onboarding_channels_desc": "सार्वजनिक आवृत्तियों की खोज करें।",
    "onboarding_security_title_card": "सुरक्षा केंद्र",
    "onboarding_security_desc_card": "गयाशील्ड स्थिति देखें।",
    "onboarding_later": "बाद में",
    "onboarding_back": "पीछे",
    "onboarding_continue": "जारी रखें",
    "onboarding_complete_setup": "सेटअप पूरा करें",
    "auth_legal_consent": "मैंने गोपनीयता नीति और उपयोग की शर्तों को पढ़ लिया है और उनसे सहमत हूँ।",
    "auth_show_terms": "उपयोग की शर्तें दिखाएं",
    "auth_recovery_mode": "रिकवरी मोड",
    "auth_recovery_import_title": "पुनर्प्राप्ति फ़ाइल आयात करें",
    "auth_recovery_import_desc": "पासवर्ड से सुरक्षित बैकअप फ़ाइल से अपनी GaiaCom कुंजियाँ पुनर्स्थापित करें। बाद में, निमोनिक और उपयोगकर्ता नाम पहले से भर जाते हैं।",
    "auth_recovery_file_pwd_placeholder": "पुनर्प्राप्ति फ़ाइल पासवर्ड",
    "auth_recovery_local_pwd_placeholder": "नया स्थानीय अनलॉक पासवर्ड न्यूनतम 12 वर्ण",
    "auth_recovery_importing": "आयात किया जा रहा है...",
    "auth_recovery_decrypt": "पुनर्प्राप्ति डिक्रिप्ट करें",
    "auth_back_to_login": "लॉगिन पर वापस जाएं",
    "auth_terms_title": "गायाकॉम बीटा उपयोग की शर्तें",
    "auth_terms_close": "बंद करें",
    "auth_cookie_title": "गायाकॉम संप्रभु रहता है।",
    "auth_cookie_desc": "हम केवल भाषा, सत्र और सुरक्षा के लिए तकनीकी रूप से आवश्यक स्थानीय संग्रहण का उपयोग करते हैं। कोई ट्रैकिंग नहीं, कोई विज्ञापन कुकीज़ नहीं, कोई तृतीय-पक्ष प्रोफ़ाइल नहीं।",
    "auth_cookie_accept": "समझ गया",
    "sc_explainer_title": "यहाँ वास्तव में क्या सुरक्षित है?",
    "sc_explainer_desc": "गायाशील्ड आपके खाते, आपके संदेशों और नेटवर्क के बीच सुरक्षात्मक परत है। यह सामग्री पर नहीं, बल्कि तकनीकी जोखिमों पर निर्णय लेता है: छेड़छाड़, रीप्ले प्रयास, अनधिकृत पहुंच, संदिग्ध लॉगिन पैटर्न और असुरक्षित गेटवे संक्रमण।",
    "sc_explainer_identity_desc": "लॉगिन विसंगतियों, सत्र जोखिमों और अन्य पहचानों तक पहुंच की जांच करता है।",
    "sc_explainer_messages_desc": "रीप्ले पैटर्न, छेड़छाड़ किए गए पैकेट और अखंडता सुविधाओं की कमी का पता लगाता है।",
    "sc_explainer_network_desc": "भरोसा गलत तरीके से प्रदर्शित होने से पहले संघ, दर सीमा और एसएमटीपी जोखिमों को चिह्नित करता है।",
    "sc_open_security_warnings": "खुली सुरक्षा चेतावनियां",
    "sc_opt_all": "सभी",
    "sc_opt_low": "निम्न",
    "sc_opt_medium": "मध्यम",
    "sc_opt_high": "उच्च",
    "sc_opt_critical": "गंभीर",
    "sc_opt_failed_login": "लॉगिन विफल",
    "sc_opt_auth_attack": "प्रमाणीकरण हमला",
    "sc_opt_rate_limit": "दर सीमा",
    "sc_opt_policy_violation": "नीति चेतावनी",
    "sc_opt_message_replay": "संदेश रीप्ले",
    "sc_node_security_data_unavailable": "नोड सुरक्षा डेटा अनुपलब्ध",
    "sc_total_events": "कुल घटनाएँ",
    "sc_login_attacks": "लॉगिन हमले",
    "sc_rate_limits_active": "सक्रिय दर सीमाएँ",
    "sc_smtp_shield_hits": "एसएमटीपी शील्ड हिट्स",
    "sc_top_event_categories": "शीर्ष घटना श्रेणियां",
    "sc_no_entries": "कोई प्रविष्टि नहीं।",
    "sc_node_audit_log": "नोड ऑडिट लॉग (हालिया)",
    "sc_no_node_events": "कोई नोड घटना नहीं।",
    "archiv": "संग्रহ",
    "entwuerfe": "ड्राफ्ट",
    "markiert": "तारांकित",
    "wichtig": "महत्वपूर्ण",
    "snoozed": "स्नूज़ किया गया",
    "papierkorb": "कचरा पेटिका",
    "spam": "स्पैम",
    "cancel": "रद्द करें",
    "error": "त्रुटि",
    "success": "सफलता",
    "kopieren": "कॉपी",
    "block_contact": "संपर्क ब्लॉक करें",
    "unblock_contact": "संपर्क अनब्लॉक करें",
    "report_contact": "संपर्क की रिपोर्ट करें",
    "check_fingerprint": "फिंगरप्रिंट सत्यापित करें",
    "export_encrypted": "निर्यात (एन्क्रिप्टेड)",
    "export_gaiaproof": "निर्यात (GaiaProof)",
    "export_password_prompt": "चैट निर्यात को एन्क्रिप्ट करने के लिए कृपया एक पासवर्ड दर्ज करें:",
    "export_success": "चैट सफलतापूर्वक निर्यात और एन्क्रिप्ट की गई।",
    "export_failed": "निर्यात विफल: ",
    "gaiaproof_export_success": "GaiaProof पैकेज सफलतापूर्वक निर्यात किया गया।",
    "gaiaproof_export_failed": "GaiaProof निर्यात विफल: ",
    "export_gaiaproof_confirm": "क्या आप सभी हस्ताक्षरों और सर्वर वितरण प्राप्तियों के साथ GaiaProof पैकेज डाउनलोड करना चाहते हैं? इसमें कुछ समय लग सकता है।",
    "group_settings_is_private": "निजी कमरा (सार्वजनिक रूप से खोजने योग्य नहीं, केवल अनुरोध द्वारा शामिल हों)",
    "group_settings_read_only": "केवल-पढ़ने के लिए मोड (केवल स्वामी और व्यवस्थापक ही संदेश भेज सकते हैं)",
    "group_settings_slow_mode": "धीमा मोड (भेजने का कूलडाउन)",
    "gsn_title": "जीएसएन सोशल फीड",
    "gsn_node_feed": "नोड फीड",
    "gsn_following_feed": "फ़ॉलो कर रहे हैं",
    "gsn_feed_empty": "कोई पोस्ट नहीं मिली।",
    "gsn_composer_placeholder": "फेडरेशन में नया क्या है?",
    "gsn_post_btn": "साझा करें",
    "gsn_profile": "उपयोगकर्ता प्रोफ़ाइल",
    "gsn_followers": "फ़ॉलोअर्स",
    "gsn_following": "फ़ॉলো कर रहे हैं",
    "gsn_bio": "विवरण / बायो:",
    "gsn_bio_label": "विवरण / बायो",
    "gsn_display_name": "प्रदर्शित नाम",
    "gsn_edit_profile": "प्रोफ़ाइल संपादित करें",
    "gsn_save_profile": "सहेजें",
    "gsn_add_image": "छवि जोड़ें (एन्क्रिप्टेड)",
    "gsn_add_emoji": "इमोजी डालें",
    "gsn_avatar_emoji": "अवतार (इमोजी)",
    "gsn_follow": "फ़ॉलो करें",
    "gsn_unfollow": "अनफ़ॉलो करें",
    "gsn_repost": "साझा करें / रीपोस्ट करें",
    "gsn_post_created": "पोस्ट सफलतापूर्वक साझा की गई।",
    "gsn_image_uploaded": "छवि एन्क्रिप्ट और अपलोड की गई।",
    "gsn_upload_failed": "छवि अपलोड विफल: ",
    "gsn_comment_placeholder": "एक टिप्पणी लिखें...",
    "gsn_delete_confirm_title": "पोस्ट हटाएं?",
    "gsn_delete_confirm_desc": "क्या आप वाकई इस पोस्ट को स्थायी रूप से हटाना चाहते हैं?",
    "gsn_delete_comment_confirm_title": "टिप्पणी हटाएं?",
    "gsn_delete_comment_confirm_desc": "क्या आप वाकई इस टिप्पणी को स्थायी रूप से हटाना चाहते हैं?",
    "gsn_report": "रिपोर्ट",
    "gsn_report_title": "उल्लंघन की रिपोर्ट करें",
    "gsn_report_category": "श्रेणी",
    "gsn_report_spam": "स्पैम / विज्ञापन",
    "gsn_report_harassment": "उत्पीड़न / अभद्र भाषा",
    "gsn_report_abuse": "दुरुपयोग",
    "gsn_report_illegal": "अवैध सामग्री",
    "gsn_report_severity": "गंभीरता",
    "gsn_report_low": "कम",
    "gsn_report_medium": "मध्यम",
    "gsn_report_high": "उच्च",
    "gsn_report_comment": "अतिरिक्त टिप्पणी",
    "gsn_report_submit": "रिपोर्ट",
    "gsn_report_submitted": "रिपोर्ट प्रशासन को सौंप दी गई है।",
    "gsn_report_post": "पोस्ट की रिपोर्ट करें",
    "report_group": "समूह की रिपोर्ट करें",
    "report_group_reason_prompt": "कृपया रिपोर्ट करने का कारण दर्ज करें (वैकल्पic):",
    "report_reason_prompt": "कृपया रिपोर्ट करने का कारण दर्ज करें (वैकल्पic):",
    "report_failed": "रिपोर्ट विफल: ",
    "report_success": "संपर्क की सफलतापूर्वक रिपोर्ट की गई।",
    "room_read_only_placeholder": "केवल स्वामी और व्यवस्थापक ही लिख सकते हैं",
    "read_only_active": "केवल-पढ़ने के लिए मोड",
    "slow_mode_active": "धीमा मोड सक्रिय",
    "kommandozentrale": "कमांड सेंटर",
    "kontakt_blockiert": "संपर्क ब्लॉक किया गया",
    "kontakt_freigegeben": "संपर्क अनब्लॉक किया गया",
    "mailbox_settings_title": "मेलबॉक्स सेटिंग्स",
    "mailbox_settings_desc": "हस्ताक्षर, भाषा, मेल फ़िल्टर प्रबंधित करें।",
    "mic_access_denied": "माइक्रोफ़ोन एक्सेस अस्वीकृत: ",
    "no_frequencies_active_desc": "संचार शुरू करने के लिए एक नया कमरा बनाएं।",
    "key_changed_warning_title": "सुरक्षा सूचना:",
    "key_changed_warning_desc": "इस प्रेषक की पहचान कुंजी को अपडेट किया गया है या यह पहले से ज्ञात कुंजी से भिन्न है। कृपया किसी अन्य सुरक्षित चैनल के माध्यम से फिंगरप्रिंट की पुष्टि करें।",
    "sc_col_category": "श्रेणी",
    "search_members": "सदस्यों को खोजें...",
    "tab_general": "सामान्य",
    "tab_members": "सदस्य",
    "tab_requests": "अनुरोध",
    "tab_invites": "आमंत्रण",
    "tab_logs": "लॉग",
    "auth_why_gaiacom": "GaiaCOM क्यों?",
    "auth_why_gaiacom_desc": "आपके गोपनीय संचार के लिए सुरक्षित, विकेंद्रीकृत विकल्प।",
    "auth_self_managed_id": "स्व-प्रबंधित आईडी",
    "auth_self_managed_id_desc": "ईमेल या फोन नंबर दिए बिना तुरंत सुरक्षित क्रिप्टोग्राफिक पहचान बनाएं।",
    "auth_gaiadrop_secure_exchange": "बिना खाते के सुरक्षित विनिमय",
    "auth_gaiadrop_benefit_e2ee": "एंड-टू-एंड एन्क्रिप्टेड",
    "auth_gaiadrop_benefit_no_login": "लॉगिन की आवश्यकता नहीं",
    "auth_gaiadrop_benefit_inbox": "प्राप्तकर्ता के इनबॉक्स में सीधी डिलीवरी",
    "auth_terms_of_use": "उपयोग की शर्तें",
    "auth_terms_of_use_show": "उपयोग की शर्तें दिखाएं",
    "auth_consent_privacy_terms": "मैंने गोपनीयता नीति और उपयोग की शर्तों को पढ़ लिया है और उनसे सहमत हूँ।",
    "auth_recovery_import_file": "रिकवरी फ़ाइल आयात करें",
    "auth_recovery_password": "रिकवरी फ़ाइल पासवर्ड",
    "auth_recovery_local_password": "नया स्थानीय अनलॉक पासवर्ड न्यूनतम 12 वर्ण",
    "auth_recovery_decrypting": "रिकवरी डिक्रिप्ट की जा रही है...",
    "auth_recovery_back": "लॉगिन पर वापस जाएं",
    "auth_cookie_sovereign": "GaiaCOM संप्रभु बना हुआ है।",
    "auth_cookie_sovereign_desc": "हम केवल भाषा, सत्र और सुरक्षा के लिए तकनीकी रूप से आवश्यक स्थानीय संग्रहण सुविधाओं का उपयोग करते हैं। कोई ट्रैकिंग नहीं, कोई विज्ञापन कुकीज़ नहीं, कोई तृतीय-पक्ष प्रोफ़ाइल नहीं।",
    "auth_cookie_sovereign_accept": "समझ गया",
    "unlock_keyboard_toggle": "⌨️ कीबोर्ड का उपयोग करें",
    "unlock_keypad_toggle": "🔢 पिन-पैड का उपयोग करें",
    "unlock_status_denied": "पहुँच अस्वीकृत / पुनः प्रयास करें",
    "unlock_status_decrypting": "वॉल्ट को डिक्रिप्ट किया जा रहा है...",
    "unlock_status_secured": "वॉल्ट सुरक्षित / लॉक किया गया",
    "auth_landing_nav_legal": "कानूनी",
    "auth_landing_nav_beta": "बीटा परीक्षण",
    "auth_landing_card1_title": "पोस्ट-क्वांटम क्रिप्टोग्राफी (ML-KEM)",
    "auth_landing_card2_title": "100% विकेंद्रीकृत",
    "auth_landing_card3_title": "शून्य-ज्ञान",
    "auth_landing_card4_title": "मेटाडेटा संरक्षण",
    "auth_landing_card5_title": "स्व-प्रबंधित आईडी",
    "auth_landing_hybrid_title": "आज की क्रिप्टोग्राफी के साथ कल की सुरक्षा।",
    "auth_landing_hybrid_desc": "GaiaCom सिद्ध शास्त्रीय कुंजी विनिमय को पोस्ट-क्वांटम कुंजी एनकैप्सुलेशन के साथ जोड़ता है। गहन सुरक्षा प्रदान करता है।",
    "auth_landing_x25519_desc": "वर्तमान उपकरणों और सुरक्षित सत्रों के लिए तेज़, सिद्ध अण्डाकार वक्र कुंजी विनिमय।",
    "auth_landing_mlkem_desc": "भविष्य के डिक्रिप्शन परिदृश्यों के विरुद्ध दीर्घकालिक गोपनीयता सुनिश्चित करने वाला पोस्ट-क्वांटम कुंजी एनकैप्सुलेशन।",
    "auth_landing_cycle_title": "सर्वर कुछ नहीं देखता। नेटवर्क केवल क्रिप्टोग्राफ़िक शोर पहुँचाता है।",
    "auth_landing_step1_title": "स्थानीय एन्क्रिप्शन",
    "auth_landing_step1_desc": "नेटवर्क या सर्वर तक पहुँचने से पहले संदेश भेजने वाले के डिवाइस पर एन्क्रिप्ट किया जाता है।",
    "auth_landing_step2_title": "ब्लोब के रूप में स्थानांतरण",
    "auth_landing_step2_desc": "पैकेट क्रिप्टोग्राफ़िक शोर के रूप में वितरित नोड्स या विकेंद्रीकृत भंडारण परतों के माध्यम से भेजा जाता है।",
    "auth_landing_step3_title": "वितरित भंडारण",
    "auth_landing_step3_desc": "कोई केंद्रीय मेलबॉक्स नहीं है। डेटा खंडित, वितरित और पूरी तरह से एन्क्रिप्टेड है।",
    "auth_landing_step4_title": "स्थानीय डिक्रिप्शन",
    "auth_landing_step4_desc": "केवल प्राप्तकर्ता की निजी कुंजी ही क्रिप्टोग्राफ़िक शोर को वापस पठनीय सामग्री में बदल सकती है।",
    "auth_landing_trinity_title": "एक प्रोटोकॉल। तीन बुनियादी ढाँचा स्तर।",
    "auth_landing_enterprise_desc": "कंपनियों, कानून फर्मों, व्यवसायों और निजी बैंकिंग के लिए। प्रशासनिक नियंत्रण और सहायता के साथ बंद संचार चैनल।",
    "auth_landing_enterprise_list1": "आंतरिक संप्रभुता और उपयोगकर्ता प्रबंधन",
    "auth_landing_enterprise_list2": "स्व-होस्टेड नोड या प्रबंधित संप्रभु क्लस्टर",
    "auth_landing_enterprise_list3": "एसएलए, समर्थन और प्रीमियम मॉड्यूल",
    "auth_landing_network_desc": "डिजिटल गोपनीयता के लिए खुला नेटवर्क। कोई डेटा व्यापार नहीं, मुक्त और एन्क्रिप्टेड संचार के लिए एक बुनियादी ढांचा।",
    "auth_landing_network_list1": "ओपन सोर्स क्लाइंट ऐप",
    "auth_landing_network_list2": "वितरित नोड्स",
    "auth_landing_network_list3": "कोई केंद्रीय डिक्रिप्शन कुंजी नहीं",
    "auth_landing_defend_desc": "सरकारी एजेंसियों, महत्वपूर्ण बुनियादी ढांचे और पृथक संचार सिलोस के लिए उच्च सुरक्षा बुनियादी ढांचा।",
    "auth_landing_defend_list1": "इंटरनेट से पूरी तरह से अलग (air-gapped) तैनाती",
    "auth_landing_defend_list2": "कस्टम ब्रांडिंग और स्रोत कोड ऑडिट",
    "auth_landing_defend_list3": "राष्ट्रीय डिजिटल संप्रभुता संप्रभु क्लस्टर",
    "auth_landing_gov_title": "खुला प्रोटोकॉल। व्यावसायिक निष्पादन। स्पष्ट कानूनी विभाजन।",
    "auth_landing_gov_desc": "GaiaCom खुले प्रोटोकॉल, खुले क्लाइंट और व्यावसायिक प्रीमियम बुनियादी ढांचे को अलग करता है। विश्वास पारदर्शिता से आता है।",
    "auth_landing_price1_desc": "ऐप स्टोर पर वितरण के लिए बॉट सुरक्षा शुल्क।",
    "auth_landing_price2_desc": "उन उपयोगकर्ताओं के लिए निःशुल्क जो कोड को स्वयं संकलित करना पसंद करते हैं।",
    "auth_landing_price3_desc": "मध्यम आकार के व्यवसायों, कानून फर्मों और संवेदनशील टीमों के लिए।",
    "auth_landing_price4_desc": "निगमों, उच्च उपलब्धता क्लस्टर, एलडीएपी और रूट एडमिन एक्सेस के लिए।",
    "auth_landing_license1_desc": "उपयोगकर्ताओं, फोर्क्स और समुदाय ऑडिट के लिए अधिकतम कोड पारदर्शिता।",
    "auth_landing_license2_desc": "प्रोटोकॉल के व्यावसायिक समापन को रोकने के लिए कॉपीलेफ्ट सुरक्षा।",
    "auth_landing_license3_desc": "एलडीएपी, रूट एडमिन एक्सेस, सुरक्षा ऑडिट, एसएलए और विशेष व्यावसायिक तर्क।",
    "auth_landing_final_title": "शून्य-विश्वास मॉडल पर आधारित संचार प्रतिरूप।",
    "auth_landing_final_desc": "GaiaCom केवल ईमेल की जगह नहीं लेता है। यह सवाल उठाता है कि संवेदनशील संचार आज भी पुराने तरीकों और पढ़ने योग्य सर्वरों पर क्यों निर्भर है।",
    "auth_landing_final_note": "नोट: यह पृष्ठ संकल्पना और विकास योजनाओं का वर्णन करता है। उत्पादन से पहले ऑडिट द्वारा सुरक्षा दावों का सत्यापन किया जाना चाहिए।"




  };

export default hi;